import { Values } from "./types";

export const shouldHide = (
  hide: boolean | ((values: Values) => boolean) | undefined,
  values: Values
) => (typeof hide === "function" ? hide(values) : !!hide);
